// extracted by mini-css-extract-plugin
export default {"addBillingAgreementDialog":"q2HxA","title":"q3Kn9","termsAndConditions":"W0GmD","download":"wwZC2","submissionMessage":"tlqPY","submissionResultMessage":"_6KBh2"};